export default __webpack_public_path__ + "static/media/gored.cab764ca.jpg";